import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deletePricingProfile } from '../../../../actions';

class PricingProfileDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeletePricingProfile, pricingProfileId } = this.props;
    dispatchDeletePricingProfile({ pricingProfileId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

PricingProfileDeleteButton.propTypes = {
  pricingProfileId: PropTypes.number.isRequired,
  dispatchDeletePricingProfile: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeletePricingProfile: deletePricingProfile,
};

export default connect(null, mapDispatchToProps)(PricingProfileDeleteButton);
